import { defineMessages } from 'react-intl'

export default defineMessages({
  cancel: {
    id: 'Cancel',
    defaultMessage: 'Cancel'
  },
  confirm: {
    id: 'OrganizationSpaces.ConfirmDeleteInputLabel',
    defaultMessage: 'Enter the name of the space before confirming this action:'
  },
  delete: {
    id: 'Delete',
    defaultMessage: 'Delete'
  },
  deleteSpace: {
    id: 'OrganizationSpaces.ConfirmDelete',
    defaultMessage: 'Delete Space?'
  },
  subMessage: {
    id: 'OrganizationSpaces.ConfirmDeleteSubMessage',
    defaultMessage:
      "This is an unrecoverable action, there's no going back! Deleting a space will delete all apps, users, and associated data."
  },
  deleteConfirm: {
    id: 'OrganizationSpaces.ConfirmDeleteWarning',
    defaultMessage: 'You are about to delete the {spaceName} space.'
  }
})
